import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';

import { TaskEditorComponent } from './../taskeditor/task-editor.component';

import { TaskDefinition } from 'app/shared/models/task-definition.model';

import { ProcessService } from './../process.service';

@Component({
  selector: 'task-list',
  providers: [ProcessService],
  templateUrl: './task-list.component.html',
})

/**
 * Component for display the process tasks list.
 */
export class TaskListComponent {
  dialogRef: MdDialogRef<any>;
  taskDefinitionRecords: TaskDefinition[];
  selectedTaskDefinition: TaskDefinition;
  processTasksLoaded = false;

  constructor(
    public dialog: MdDialog,
    public viewContainerRef: ViewContainerRef,
    private processService: ProcessService,
    private snackBarService: SnackBarService,
    private trackingService: TrackingService) { }

  // Get task definitions list records as per process selected.
  getTaskList(processKey: string) {
    this.processTasksLoaded = false;
    this.taskDefinitionRecords = [];
    this.processService.getProcessTasks(processKey)
        .subscribe(response => {
        this.taskDefinitionRecords = response;
        this.processTasksLoaded = true;
    });
  }

  // Open dialog having text editor to update task guide text.
  openTaskGuideUpdateDialog() {
    const config = new MdDialogConfig();
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(TaskEditorComponent, config);
    this.dialogRef.componentInstance.argTaskDetailsData = this.selectedTaskDefinition;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      if (result) {
        this.taskDefinitionRecords[this.taskDefinitionRecords.indexOf(this.selectedTaskDefinition)] = result;
      }
      this.selectedTaskDefinition = null;
    });
  }

  // Link to open dialog having text editor to update task definition guide text.
  editTaskGuide(value: TaskDefinition): void {
    this.selectedTaskDefinition = value;
    this.openTaskGuideUpdateDialog();
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/processes/tasklist/task-list.component.ts